//每個變量對應每個頁面文件
let home = {
  // nav: [
  //   // {
  //   //   title: "Order Query",
  //   //   list: [
  //   //     {
  //   //       name: "Order Orders",
  //   //     },
  //   //     {
  //   //       name: "Product Query",
  //   //     },
  //   //   ],
  //   // },
  //   {
  //     title: "Orders",
  //     list: [
  //       {
  //         name: "Waybill Management",
  //       },
  //     ],
  //   },
  //   {
  //     title: "Products",
  //     list: [
  //       {
  //         name: "Product Details",
  //       },
  //       {
  //         name: "Add/Edit Product",
  //       },
  //       {
  //         name: "Product Inventory",
  //       },
  //     ],
  //   },
  //   {
  //     title: "Promotions",
  //     list: [
  //       {
  //         name: "Promotion Rules",
  //       },
  //     ],
  //   },
  //   {
  //     title: "Shop Display",
  //     list: [
  //       {
  //         name: "Shop Information",
  //       },
  //       {
  //         name: "Category",
  //       },
  //       {
  //         name: "Campaign",
  //       },
  //       {
  //         name: "Banners",
  //       },
  //     ],
  //   },
  //   {
  //     title: "Setting",
  //     list: [
  //       {
  //         name: "Company Information",
  //       },
  //       {
  //         name: "Account Management",
  //       },
  //       {
  //         name: "Shop List",
  //       },
  //     ],
  //   },
  //   {
  //     title: "Report",
  //     list: [
  //       // {
  //       //   name: "Sales Summary (By Order)",
  //       // },
  //       // {
  //       //   name: "Sales Summary(By Products)",
  //       // },
  //       // {
  //       //   name: "Order Summary",
  //       // },
  //       {
  //         name: "Order Record",
  //       },
  //       {
  //         name: "Products Record",
  //       },
  //       {
  //         name: "Settlement Report",
  //       },
  //       {
  //         name: "Sales Record",
  //       },
  //       {
  //         name: "Order Record By Products",
  //       },
  //     ],
  //   },
  // ],

  logout: "LogOut",
  shopList: "Shop List",
  changeSuccess: "Shop switched",
  cancel: "Cancel",
  confirm: "Confirm",
  switchShop: "Switch Shop",
  reload: "Refresh",
};

let login = {
  title: "MyBookOne",
  subTitle: "SIS Platform Management System",
  loginName: "Login Email",
  password: "Password",
  submit: "Submit",
  rulesName: "Login Is Null",
  rulesPassword: "Password Is Null",
  remember: "Remember Me",
  forgot: "Forgot Password?",
  success: "Success",
};
let resetPass = {
  title: "MyBookOne",
  subTitle: "SIS Platform Management System",
  loginName: "Login",
  loginEmail: "Login Email",
  password: "New Password",
  password2: "Confirm Password",
  oldPassword: "Old Password",
  submit: "Update Password",
  oldPasswordRules: "Please enter old password",
  usernameRules: "Please ente E-mail",
  success: "Success",
  code: [
    "Please ente E-mail",
    "Please ente code",
    "Reacquire in ",
    " seconds",
    "Get a verification code",
  ],
};

let orderQuery = {
  title: "Search Order Query",
  breadcrumbTitle: "Order Query",
  breadcrumbList_1: "Report",
  breadcrumbList_2: "Waybill/Orders",

  queryStatus: "Query Status",
  period: "Period",
  transaction: "Transaction ID",
  search: "Search",
  searchTips: "* Within 90 Days",
  results: "Results",
  rows: "Rows",
  emptyText: "No data found",
  selectTimeType: "Please choose types of time",
};

let promotionRules = {
  title: "Search Pomotion Rule",
  breadcrumbTitle: "Promotion Rules",
  breadcrumbList_1: "Promotions",
  breadcrumbList_2: "Promotion Rules",

  startEnd: "Promotion Period",
  statusArrTitle: "Promotion Status",
  queryStatus: "Query Status",
  period: "Period",
  search: "Search",
  edit: "Edit",
  addPromotion: "Add New Promotion Rule",
  results: "Results",
  rows: "Rows",
  emptyText: "No data found",
  createTime: "CreateTime",
  activityName: "Promotion Name",
  status: "Status",
  invisible: "Invisible",
  on: "ON",
  off: "OFF",
  draft: "Draft",
  edit: "Edit",
  delete: "Delete",
  deleteBatch: "deleteBatch",

  tab1: "General Information",
  tab2: "Promotion Rule",
  tab3: "Product List",
  tab3: "Product List",
  tab4: "Promotion Introduction",

  createDate: "Create Date",
  createdBy: "Created By",
  promotionId: "Promotion ID",
  promotionDescription: "Promotion Description",
  promotionType: "Promotion Type",
  startTime: "Promotion Start Date",
  endTime: "Promotion End Date",
  promotionTime: "Promotion Period",
  lastUpdated: "Last Updated",
  lastUpdatedBy: "Last Updated By",

  activeMode: "Active Mode",
  discountOffRate: "Discount Off Rate",

  addProduct: "Add Product(s)",
  addBatch: "Add Batch",
  activityType: "Promotion Type",
  activityName: "Promotion Name",
  activityUrl: "Promotion Cover",
  draftSave: "Save as Draft",
  submit: "Submit",
  success: "Success",

  // form rule error tips
  quantityTips: "Please fill in the quantity",
  fixedPriceTips: "Please fill in the Fixed Price discount",
  fixedDiscount: "Please fill in the discount",

  RuleEmpty: "Promotion Rule can't be empty",

  removeTips: "It will delete the Promotion",

  discountTips: "Example: 5% off, please fill in 9.5",
  checkDiscountTips:
    "Please check the discount, the number should be between 1 - 10. ",
  checkQuantityTips: "Please check the quantity, it should be larger than 0.",
  checkPriceTips: "Please check the price, it should be larger than 0.",
  imageUrlEmptyTips: "Please upload the promotion cover picture!",
  activityNameEmptyTips: "Please fill the promotion name!",
  activityTypeEmptyTips: "Please choose the promotion type!",
  startTimeEmptyTips: "Please choose the promotion start date!",
  endTimeEmptyTips: "Please choose the promotion end date!",
  statusEmptyTips: "Please select status!",
  promotionTimeTips: "Please choose the promotion period!",

  // tab2

  unifiedPrice: "Unified Price",
  unifiedDiscount: "Unified Discount",
  purchaseQuantity: "Purchase quantity",

  // tab5
  discount: "Discount",
  quantity: "Quantity",
  price: "Price",

  reduce_assgnedAlert: "Please confirm the price",
  reduce_direct_discountAlert: "Please confirm the discount",
  tips: "Tips",
  confirm: "Confirm",
  rulesTip: "Please set the rules",
};

let productQrders = {
  title: "Search Order Query",
  breadcrumbTitle: "Order Query",
  breadcrumbList_1: "Report",
  breadcrumbList_2: "Waybill/Orders",

  queryStatus: "Query Status",
  period: "Period",
  transaction: "Transaction ID",
  search: "Search",
  searchTips: "* Within 90 Days",
  results: "Results",
  rows: "Rows",
  emptyText: "No data found",
};

let shopInformation = {
  breadcrumbTitle: "Shop Information",
  breadcrumbList_1: "Shop Display",
  breadcrumbList_2: "Shop Information",

  //門店信息編輯
  save: "Save",
  preview: "Preview",
  tab1: "ShopInfo",
  tab2: "ShopDescription",
  tab3: "CustomerServices",
  tab4: "T&C",
  tab5: "BusinessDays",
  max: "max",
  words: "words",
  maxTips1: "",
  maxTips2: " words typed.",

  //tab1
  merchantNum: "Merchant Num",
  aliasName: "Shop Alias (Eng.)",
  shopNameChi: "Shop Name(Chi.)",
  shopNameEng: "Shop Name(Eng.)",
  logo: "Merchant Logo",
  theme: "Color Theme",
  banner: "Top Banner",
  shopLocation: "Shop Location",
  addressChi: "Address (Chi.)",
  addressEng: "Address (Eng.)",
  contact: "Contact No.",
  district: "District",
  categoryId: "Merchant Category",
  sequence: "Ordering",
  //tab2
  briefDescription: "Short Description (Chi.)",
  briefDescriptionEng: "Short Description (Eng.)",
  longDescription: "Long Description (Chi.)",
  longDescriptionEng: "Long Description (Eng.)",
  metaKeyword: "Meta Keywords (Chi.)",
  metaKeywordEng: "Meta Keywords (Eng.)",
  mateDescription: "Meta Description (Chi.)",
  mateDescriptionEnd: "Meta Description (Eng.)",

  //tab3
  contactName: "Contact Name",
  contactPhone: "Contact Phone No.",
  contactEmail: "Contact Email",
  serviceCentreAddress: "Service Centre Address(Chi.)",
  serviceCentreAddressEng: "Service Centre Address(Eng.)",

  //tab4
  termsChi: "Merchant T&C(Chi.)",
  termsEng: "Merchant T&C(Eng.)",
  deliveryTermsChi: "Delivery Terms(Chi.)",
  deliveryTermsEng: "Delivery Terms(Eng.)",

  //tab5
  open: "Open",
  close: "Close",
  publicHoliday: "Public Holiday",
  viewPublicHoliday: "View public holidays",
  holidayField: "Holiday",
  holidayList: "Holiday List",
  startTimeField: "Start Time",
  endTimeField: "End Time",
  emptyText: "No data found",
  success: "Success",

  addCertificate: "Add",

  // form name
  nameEng: "Company Name (English)",
  nameChi: "Company Name (Chinese)",
  registerArea: "Place of Incorporation",
  registerNum: "Certificate of Incorporation No.",

  addressInfo: "BR Address",
  country: "Country",
  region: "Region",
  street: "Street & Building",
  room: "Room",
  brCertificateNum: "Business Registration Certificate No.",
  brCertificateUrl: "Business Registration Certificate",
  download: "download",
  brExpiryDate: "BR Expiry Date",
  introductionUrl: "Company Profile",
  businessEmail: "Company Email",

  contact: "Contact",
  contactLastName: "Last Name",
  contactFirstName: "First Name",
  contactPosition: "Position",
  contactDepartment: "Department",
  contactEmail: "Email (For Login Use)",
  contactPersonalPhone: "Phone",
  officePhoneNumber: "Mobile",
  fax: "Fax",

  product: "Shop & Product",
  shopName: "Shop Name (Chinese)",
  shopNameEng: "Shop Name (English)",
  productCategory: "Product Category",
  productSaleCount: "No. of Product for Sales",
  isAgreeHktv: "Online Shop Experience",
};

let shopCategory = {
  breadcrumbTitle: "Product Category",
  breadcrumbList_1: "Shop Display",
  breadcrumbList_2: "Category",
  add: "Add Category",
  addProduct: "Add Product",
  emptyText: "No data found",
  save: "Save",
  edit: "Edit",
  delete: "Delete",
  addToCat: "Add To Category",
  addInBatch: "Add In Batch",
  deleteInBatch: "Delete In Batch",
  topInBatch: "Top In Batch",
  update: "Update",
  nameChi: "Name",
  nameEng: "NameEng",
  thumb: "Thumb",
  cateType: "CateType",
  parentId: "ParentId",
  parentName: "parentName",
  status: "IsShow",
  sort: "Ordering",
  code: "Code",
  isShow: "IsShow",
  displayed: "Displayed",
  visible: "Visible",
  invisible: "Invisible",
  forbidden: "Forbidden",
  content: "Content",
  success: "Success",
  addAudit: "Add successfully, after the approval will be displayed",
  import: "Import",
  file: "File",
  confirm: "Confirm",
  cancel: "Cancel",
  downloadTemp: "Template",
  download: "Download",
  results: "Results:",
  rows: "Rows",

  addToCategoryTips:
    "This will add the product(s) to the selected Category.  Are you sure?",
  addBatchTips: "This will add the products in batch.",
  chooseProductTips: "Please choose product(s).",
  deleteInBatches: "This will delete the products in batch.",
  pinInBatches: "This will pin the products to top in batch.",
  fileUploadTips: "Please choose file to upload",

  codeTips: "Code can't be empty.",
  nameChiTips: "Name can't be empty.",
  thumbTips: "Please upload the cover picture.",
  displayedTips: "State can't be empty.",
};

let shopCampaign = {
  breadcrumbTitle: "Product Campaign",
  breadcrumbList_1: "Shop Display",
  breadcrumbList_2: "Campaign",
  add: "Add Campaign",
  addProduct: "Add Product",
  emptyText: "No data found",
  save: "Save",
  edit: "Edit",
  delete: "Delete",
  addToCam: "Add To Campaign",
  addInBatch: "Add In Batch",
  deleteInBatch: "Delete In Batch",
  topInBatch: "Top In Batch",
  addAudit: "Add successfully, after the approval will be displayed",
  update: "Update",
  success: "Success",
  nameChi: "Campaign Name(Chi.)",
  nameEng: "Campaign Name(Eng.)",
  cateType: "CateType",
  parentId: "ParentId",
  status: "Displayed",
  sort: "Ordering",
  code: "Code",
  isShow: "IsShow",
  displayed: "Displayed",
  visible: "Visible",
  forbidden: "Forbidden",
  invisible: "Invisible",
  content: "Content",
  success: "Success",
  // addAudit: "添加成功审核通过后显示",
  import: "Import",
  file: "File",
  confirm: "Confirm",
  cancel: "Cancel",
  downloadTemp: "Template",
  download: "Download",
  results: "Results:",
  rows: "Rows",

  onlyNumberAndCharacterTips: "Only numbers and characters are allowed.",
  inputErrorTips: "Input error",
  addToCampaignTips:
    "This will add the product(s) to the selected Campaign.  Are you sure?",
  codeTips: "Code can't be empty.",
  nameChiTips: "Name can't be empty.",
  thumbTips: "Please upload the cover picture.",
  displayedTips: "State can't be empty.",
};

let shopBanners = {
  breadcrumbTitle: "Shop Banners",
  breadcrumbList_1: "Shop Display",
  breadcrumbList_2: "Banners",
  add: "Add Banner",
  emptyText: "No data found",
  save: "Save",
  edit: "edit",
  results: "Results:",
  rows: "Rows",
  linkType: "Link Type",
  linkContent: "Link Content",
};

let shopBannerForm = {
  nameChi: "Campaign Name(Chi.)",
  nameEng: "Campaign Name(Eng.)",
  status: "Status",
  order: "Ordering",
  linkToBanner: "Link to Banner",
  display: "Displayed",
  endTime: "End Date",
  startTime: "Start Date",
  promoImage: "Promo Image",
  productNameChi: "Product Name(Chi.)",
  categoryChi: "Category(Chi.)",
  barcode: "SKU ID(Barcode)",
  content: "Content",
  select: "Select",
  createTime: "CreateTime",
  shopNum: "shopNum",
  shop: "shop",
  submit: "Submit",
  approved: "Approved",
  rejected: "Rejected",
  delete: "Delete",
  edit: "Edit",
  visible: "Visible",
  invisible: "Invisible",
  success: "Success",
  categoryName: "Category Name",
  categoryCode: "Category Code",
  campaignName: "Campaign Name",
  campaignCode: "Campaign Code",

  nameChiTips: "Banner Name can't be empty.",
  shopNumTips: "Shop Num can't be empty.",
  displayTips: "Display can't be empty.",
  linkToTips: "Link can't be empty.",
  webImgTips: "Web Img can't be empty.",
  appImgTips: "Web Img can't be empty.",
  endTimeTips: "End Time can't be empty.",
  startTimeTips: "Start Time can't be empty.",
  timeTips: "The start time cannot be greater than the end time",
};

let productDetails = {
  title: "Product Details",
  title2: "Set Details",
  breadcrumbTitle: "Product Details",
  breadcrumbTitle2: "Set Details",
  breadcrumbList_1: "products",
  breadcrumbList_2: "Product Details",
  breadcrumbList_2_1: "Set Details",

  queryStatus: "Product Status",
  period: "Period",
  transaction: "Product Name",

  onlineStatus: "OnlineStatus",
  productType: "Product Type",

  search: "Search",
  results: "Results",
  rows: "Rows",
  emptyText: "No data found",
  action: "Action :",
  otherHandling: "Other Handling :",
  download: "Download",
  downloadLog: "Download Log",
  online: "Online",
  offline: "Offline",
  invisbile: "Invisible",

  batch: "Product export",
  batchTips: "Content can't be empty.",
  batchDownload: "Download Excel",
  batchSearch: "Search",

  //auditStatus
  submit: "Submit",
  approved: "Approved",
  rejected: "Rejected",
  // hide: "Hide （待確定是否需要）",

  //Storage Type
  onlyInStore:'Only-in-store',
  inAndOutStore:'In/Out-store',

  //saleStatus
  online: "Online",
  offline: "Offline",
  invisible: "Invisible",

  oneOfBelow: "One of below:",
  book: "BOOK",
  stat: "Non-Book",
  edit: "Edit",

  //商品编辑
  tab1: "Basic Information",
  tab2: "Further Information (BOOK)",
  tab3: "Packing  Information",
  tab4: "Warranty",
  tab5: "Others",
  tab6: "Further Information (NO-BOOK)",
  save: "Save",
  success: "Success",
  // tab6: "Others",
  chooseProductTips: "Please choose product",

  // form rule tips
  shopcategoryTips: "Shop classification, multiple separated by ','",
  extraDeliverDaysTips: "xxx days",
  extraDeliverDaysErrTips: "Please enter Extra Delivery Time",
  shopNumTips: "Please enter the Merchant ID!",
  machProductIDTips: "Please enter the Model/Product ID/SKU!",
  typeTips: "Please select Primary Type Code!",
  categoryTips: "Please enter the Primary Class Code!",
  saleStatusTips: "Please select online status!",
  brandTips: "Please enter the Brand (Chi)!",
  recommendPriceTips: "Please enter the Recommend Retail Price(HKD)!",
  salePriceTips: "Please enter the Selling Price(HKD)!",
  productCostTips: "Please enter the Product Cost(HKD)!",
  nameTips: "Please enter the Product Name (Chi)!",
  shortNameTips: "Please enter the Product Short Name (Chi)!",
  summaryTips: "Please enter the Short Description (Chi)!",
  introductionTips: "Please enter the Long Description (Chi)!",
  deliveryTips: "Please select the delivery method!",
  agentTypeTips: "Please select the agent type!",
  publisherTips: "Please enter the Publisher!",
  pubDateTips: "Please enter the Publication Date!",
  countryOfPublicationTips: "Please select the country of publication!",
  authorTips: "Please enter author!",
  pageTips: "Please enter pages!",
  languageTips: "Please language!",
  editionTips: "Please enter the edition!",
  contentAbstractTips: "Please enter a summary of the content!",
  placeOfManufacturingTips: "Please enter the place of manufacture!",
  weightTips: "Please enter weight!",
  lengthTips: "Please enter length!",
  depthTips: "Please enter depth!",
  heightTips: "Please enter height!",
  coverTips: "Product Cover can't be empty.",

  textareaTips:
    "Please type the Model ID or Barcode or Article Master here, only one number is allowed for each row with no extra space. </br>For example:",
};
let setDetails = {
  add: "Add",
  delete:"Delete",
  modelId:"ModelId Num can't be empty.",
  tab2:"Product List",
  mchProductPackageItemsTips:"Product List Cover can't be empty.",
  deleteTips: "This will delete the data permanently.  Are you sure?",
};

let scrapProducts={
  scrapProducts:"Damaged Products",
  title:"Damaged Products",
  add:"Add",
  addDialog:"Add Damaged Products",
  batchAdd:"Add Batch",
  selectGoods:"Select",
  batchAddDialog:"Add Batch",
  step2Title:"Add Batch Damaged Products",
  editStep1Text:"Download Template",
  editStep2Text:"Select a Template",
  stepButton:"Upload",
  delete:"Delete",
  success:"Success",
  queryStatus:"Damaged Product Status",
  transaction:"Damaged Product Name",
  // removeTips:"It will delete the Promotion"
  removeTips:"This will delete the data permanently.  Are you sure?",
  batchAddErrDialog:"Error message",
  salePriceRules:"Please enter sales price.",
  productNumRules:"Please select product",
  onlyintegers:"Sales Price(only integers)"
}

let scrapProductsInventory ={
  title:"Batch Mode",
  breadcrumbTitle:"Damaged Products Inventory",
  breadcrumbList_1:"products",
  breadcrumbList_2:"Damaged Products Inventory",
  editStep1Text:"Download Damaged Products Inventory",
  editStep2Text:"Update and Upload Damaged Product Inventory(xlsx Format)"
}



let addEditProduct = {
  title: "Add/Edit Product",
  breadcrumbTitle: "Add/Edit Product",
  breadcrumbList_1: "products",
  breadcrumbList_2: "Add/Edit Product",

  step1Title: "Add New Product(s)",
  step2Title: "Edit Existing Product(s)",

  step: "Step",

  stepButton: "Upload",
  download: "Download",

  addStep1Text: "Download Template",
  addStep2Text: "Upload Product File(xlsx Format)",
  addStep3Text: `Upload Product Images (ZIP Format, file size < 200Mb, see "Guideline")`,

  editStep1Text: `Download Product Information through "Product Details"`,
  editStep2Text: `Edit and Upload Product File(xlsx Format)`,
  editStep3Text: `Upload Product Images (ZIP Format,file size < 200Mb,see "Guideline") (OPTIONAL) `,
};

let productInventory = {
  title: "Batch Mode",
  breadcrumbTitle: "Product Inventory",
  breadcrumbList_1: "products",
  breadcrumbList_2: "Product Inventory",

  step1Title: "Add Inventory (Batch Mode)",
  step2Title: "Edit Existing Product(s)",

  step: "Step",

  stepButton: "Upload",
  download: "Download",

  addStep1Text: "Download Template",
  addStep2Text: `Upload Inventory File(xlsx Format,see "Guideline")`,

  editStep1Text: `Download Product Inventory`,
  editStep2Text: `Update and Upload Product Inventory(xlsx Format)`,

  individualMode: "Individual Mode",

  searchTitle1: "SKU ID / Barcode",
  searchTitle2: "Model ID",
  searchTitle3: "Product Name",

  results: "Results",
  rows: "Rows",

  tableColumn1: "Marchant ID",
  tableColumn2: "SKU ID(Barcode)",
  tableColumn3: "Model",
  tableColumn4: "Product Name(Chi.)",
  tableColumn5: "Available Stocks",
  tableColumn6: "In Progress",
  tableColumn7: "Add/Deduct ",
  tableColumn8: "Adjust Quantity",
  tableColumn9: "Storage Type",
  tableColumn10: "In-store Stocks",
  tableColumn11: "Out-of-store Stocks",
  productNum: "Article Master",
  save: "Save",
  inventoryEmptyTips: "Please update the inventory",
};

let companyInformation = {
  breadcrumbTitle: "Company Information",
  breadcrumbList_1: "Setting",
  breadcrumbList_2: "Company Information",
  tab1: "Company Information",
  tab2: "Company Info.",
  save: "Save",
  nameEngTips: "Please enter the Company Name (English)",
  nameChiTips: "Please enter the Company Name (Chinese)",
  registerAreaTips: "Please enter the Company Place of Incorporation",
  registerNumTips: "Please enter the Certificate of Incorporation No.",
  countryTips: "Please enter the Country",
  regionTips: "Please enter the Region",
  streetTips: "Please enter the Street & Building",
  roomTips: "Please enter the Room",
  brCertificateNumTips:
    "Please enter the Business Registration Certificate No.",
  brCertificateUrlTips: "Please upload the Business Registration Certificate",
  brExpiryDateTips: "Please select the BR Expiry Date",
  introductionUrlTips: "Please upload the Company Profile",
  businessEmailTips: "Please enter the Company Email",
  contactFirstNameTips: "Please enter the Last Name",
  contactLastNameTips: "Please enter the First Name",
  contactPositionTips: "Please enter the Position",
  contactDepartmentTips: "Please select the Department",
  contactPersonalPhoneTips: "Please enter the Phone",
  officePhoneNumberTips: "Please enter the Mobile",
  isAgreeHktvTips: "Please enter the Online Shop Experience",
  productCategoryTips: "Please select the Online Shop Product Category",
  productSaleCountTips: "Please select the No. of Product for Sales",
  productSaleCountOptions: "more than 200",
  success: "Success",
  err: "Information must not be empty",
  contactEmailTips: "Please select the Email",
};

let accountManagement = {
  // breadcrumbTitle: "Account Management",
  breadcrumbList_1: "Setting",
  breadcrumbList_2: "Account Management",
  breadcrumbTitle: "Account List",
  save: "Save",
  add: "Add",
  delete: "Delete",
  emptyText: "No data found",

  tips: "Tips",
  // tipsText: "刪除該數據",
  confirm: "Confirm",
  cancel: "Cancel",

  createTime: "Create Date",
  lastUpdated: "Last Updated",
  loginEmail: "Login Email",
  password: "Password",
  confirmPassword: "Confirm Password",
  shop: "Merchant",
  loginUser: "Login User",
  status: "Status",
  description: "A/C Description",
  edit: "Edit",
  results: "Results:",
  rows: "Rows",
  save: "Save",
  editAccount: "Edit Account",
  accessRights: "Access Rights",
  pdEmail: "Pick/Delivered Email",
  pick: "Pick",
  delivered: "Delivered",

  pdEmailRules: "Pick/Delivered Email can't be empty.",
  loginUserRules: "Login User can't be empty.",
  loginUserRulesTips: `Only "A-Z, a-z, 0-9, @, .com, .con" are allowed for the Login User`,
  loginEmailRules: "Login Email can't be empty.",
  expirydateRules: "A/C Valid To can't be empty.",
  shopIdsRules: "Shop can't be empty.",
  validatePass: [
    "Please enter your password.",
    "Those passwords didn't match!",
  ],
  validateErr: "This field can't be empty.",
  passMin: "Make sure it's at least 5 characters",
  format: 'Only "A-Z, a-z, 0-9, _" are allowed',
  success: "Success",
  expirydate: "A/C Valid To",

  frozen: "Frozen",
  online: "Online",
  delete: "Delete",

  infinite: "Infinite",

  week: "One Week",
  month: "One Month",
  year: "One Year",
};

// let byOrder = {
//   title: "Search Waybill",
//   breadcrumbTitle: "Report - Order Summary",
//   breadcrumbList_1: "Report",
//   breadcrumbList_2: "Order Summary",

//   queryStatus: "Status",
//   period: "Period",
//   transaction: "Transaction ID",
//   search: "Search",
//   searchTips: "* Within 3 months",
//   results: "Results",
//   rows: "Rows",
//   emptyText: "No data found",
//   download: "Download as Excel",
// };

// let orderSummary = {
//   title: "Search Waybill",
//   breadcrumbTitle: "Report - Order Summary",
//   breadcrumbList_1: "Report",
//   breadcrumbList_2: "Order Summary",

//   queryStatus: "Status",
//   period: "Period",
//   transaction: "Transaction ID",
//   search: "Search",
//   searchTips: "* Within 3 months",
//   results: "Results",
//   rows: "Rows",
//   emptyText: "No data found",
//   download: "Download as Excel",
// };

// let byProducts = {
//   title: "Search Waybill",
//   breadcrumbTitle: "Report - Order Summary",
//   breadcrumbList_1: "Report",
//   breadcrumbList_2: "Order Summary",

//   queryStatus: "Status",
//   period: "Period",
//   transaction: "Transaction ID",
//   search: "Search",
//   searchTips: "* Within 3 months",
//   results: "Results",
//   rows: "Rows",
//   emptyText: "No data found",
//   download: "Download as Excel",
// };

let shopList = {
  breadcrumbTitle: "Shop List",
  breadcrumbList_1: "Setting",
  breadcrumbList_2: "Shop List",
  add: "Add Shop",
  emptyText: "No data found",
  save: "Save",
  edit: "Edit",
  delete: "Delete",

  shopNameChi: "ShopName (Chi.)",
  shopNameEng: "ShopName (Eng.)",
  merchantNum: "ShopNum",
  merchantId: "MerchantID",
  status: "Status",
  statusDeveloping: "Developing",
  statusOnline: "Online",
  statusFrozen: "Frozen",
  statusOffline: "Offline",
  statusInitial: "Initial",
  createTime: "CreateTime",
  audit: "AuditStatus",
  auditPending: "Pending Review",
  auditApproved: "Approved",
  auditRejected: "Rejected",
  auditInitial: "Initial",
  results: "Results:",
  rows: "Rows",
  online: "Online",
  offline: "Offline",

  businessChooseTips: "At least choose one business day.",
  shopNameTips: 'Only "A-Z, a-z, 0-9, _" are allowed for the Shop Name.',
  shopAliasEmpty: "Shop Alias can't be empty.",
  shopNameEmpty: "Shop Name can't be empty.",
  categoryEmpty: "Merchant Category can't be empty.",
  logoEmpty: "Please upload the logo image.",
  colorThemeEmpty: "Color Theme can't be empty.",
  topBananerEmpty: "Top Banner can't be empty.",
  chooseShopListTips: "Please choose a shop",
};

let waybillManagement = {
  breadcrumbTitle: "Waybill Management",
  breadcrumbList_1: "Order",
  breadcrumbList_2: "Waybill Management",
  title: `Master Waybill (Generated the "Picked" WB in a list for "Warehouse Entry Process", 1 WB will be listed in 1 Master Waybill)`,
  generateMasterWB: "Generate Master WB",
  generate: "Generate",
  LastVersion: "Last Version",
  exportHistory: "Export History",
  exportMasterWB: "Export Master WB",
  searchWaybill: "Search Waybill",
  status: "Status",
  period: "Period",
  emptyText: "No data found",
  results: "Results",
  rows: "Rows",
  action: "Action",
  pickingList: "PickingList By Item",
  pickingConfirm: "confirm",
  printWB: "Print WB",
  acknowledge: "Acknowledge",
  pick: "Pick",
  other: "Other Merchant Handling (Before Picked)",
  cancel: "Cancel",
  delay: "Delay",
  searchTips: "* Within 30 Days",
  search: "Search",
  success: "Success",
  tips: "Tips",
  confirm: "Confirm",
  cancel: "Cancel",
  resent: "退回理由",
  resentNull: "沒有退回信息",
  exportMasterWBError: "Please choose WB",
  pickListItemTips: 'Please choose "Picking List"',
};

let warehousingManagement = {
  breadcrumbTitle: "Warehousing Management",
  breadcrumbList_1: "Order",
  breadcrumbList_2: "Warehousing Management",
}

let notFound = {
  goToPage: "Go To Home",
  tips: "UH OH! Not the correct URL",
};

let ymdCard = {
  year: "YYYY",
  month: "YYYY-MM",
  date: "YYYY-MM-DD",
  typeMonth: "Month",
  typeYear: "Year",
  typeDay: "Day",
};

let batchAddCard = {
  productFilePathErr: 'Please upload document(s) in "Step 2"',
  imageFilePathErr: 'Please upload document(s) in "Step 3"',
  confirmText: "Do you want to submit?",
  tips: "Tips",
  confirm: "Confirm",
  upload: "Upload",
  cancel: "Cancel",
  success: "success",
  err: "error",
  error: "error",
  file: "File",
  xlsxErrorTips: "Choose Excel(.xlsx) file to upload.",
  uploadFailedTips: "Upload Failed!",
};

let batchEditCard = {
  productFilePathErr: 'Please upload document(s) in "Step 2"',
  confirmText: "Do you want to submit?",
  tips: "Tips",
  confirm: "Confirm",
  cancel: "Cancel",
  success: "success",
  file: "File",
};

let orderRecord = {
  title: "Search Waybill",
  breadcrumbTitle: "Report - Order Record",
  breadcrumbList_1: "Report",
  breadcrumbList_2: "Report - Order Record",
  queryStatus: "Transaction Status",
  period: "Period",
  transaction: "Transaction ID",
  search: "Search",
  searchTips: "* Within 6 months",
  results: "Results",
  rows: "Rows",
  emptyText: "No data found",
  view: "View Details",
};

let productsRecord = {
  title: "Search Waybill",
  breadcrumbTitle: "Report - Products Record",
  breadcrumbList_1: "Report",
  breadcrumbList_2: "Report - Products Record",
  queryStatus: "Transaction Status",
  period: "Period",
  transaction: "Transaction ID",
  search: "Search",
  searchTips: "* Within 6 months",
  results: "Results",
  rows: "Rows",
  emptyText: "No data found",
};
let SettlementReport = {
  title: "Search Waybill",
  breadcrumbTitle: "Report - Settlement Report",
  breadcrumbList_1: "Report",
  breadcrumbList_2: "Report - Settlement Report",
  transaction: "Internal Only",
  search: "Search",
  searchTips: "* Within 6 months",
  results: "Results",
  rows: "Rows",
  emptyText: "No data found",
  download: "Download",
};
let salesRecord = {
  title: "Search Waybill",
  breadcrumbTitle: "Report - Sales Record",
  breadcrumbList_1: "Report",
  breadcrumbList_2: "Report - Sales Record",
  transaction: "Internal Only",
  search: "Search",
  searchTips: "* Within 6 months",
  results: "Results",
  rows: "Rows",
  emptyText: "No data found",
  time: "Period (By Order Last Updated)",
  updated: "Updated",
};
let orderRecordByProducts = {
  title: "Search Waybill",
  breadcrumbTitle: "Report - Order Record By Products",
  breadcrumbList_1: "Report",
  breadcrumbList_2: "Report - Order Record By Products",
  transaction: "Internal Only",
  search: "Search",
  searchTips: "* Within 6 months",
  results: "Results",
  rows: "Rows",
  emptyText: "No data found",
  promotion: "Promotion",
};

let ymdCardV2 = {
  timeType: "Date Type",
  time: "Date",
  startDate: "StartDate",
  endDate: "EndDate",
};

let common = {
  download: "Download",
  downloading: "Downloading",
  continueTips: "Do you want to continue?",
  notDataFound: "No data found",
  changeTips: "It will change the status",
  tips: "Tips",
  confirm: "Confirm",
  cancel: "Cancel",
  incorrectInfo: "Incorrect information",
  uploaderInfo: "Resolution",
  mustNotEmpty: "This field can't be empty.",
  deletePermanentTips: "This will delete the data permanently.  Are you sure?",
};

// admin-ui 语言
let adminUI = {
  form: {
    resetBtn: "reset",
    confirmBtn: "confirm",
    cancelBtn: "cancel",
    formTitle: "edit",
    formValidateErr: "Please check the input items as prompted!",
    pleaseInput: "Please enter",
    submitSuccess: "Submitted successfully!",
    submitErr: "Submission failed! The reason:",
  },
  search: {
    selete: "Please choose",
    input: "Please enter",
    doSearch: "Search",
  },

  adminBase: {
    addBtn: "New",
    searchBtn: "Search",
    edit: "Edit",
    delete: "Delete",
  },

  table: {
    view: "Detail",
    operation: "Action",
    confirm: "confirm",
    selected: "selected",
    sort: "sort",
    save: "save",
  },
};

let all = {
  download: "Download",
};

export default {
  common,
  login,
  home,
  notFound,
  orderQuery,
  productQrders,
  ymdCard,
  shopInformation,
  shopCategory,
  shopCampaign,
  shopBanners,
  shopBannerForm,
  productDetails,
  addEditProduct,
  productInventory,
  batchAddCard,
  batchEditCard,
  promotionRules,
  companyInformation,
  accountManagement,
  // byOrder,
  // orderSummary,
  // byProducts,
  shopList,
  waybillManagement,
  warehousingManagement,
  resetPass,
  orderRecord,
  productsRecord,
  SettlementReport,
  salesRecord,
  orderRecordByProducts,
  ymdCardV2,
  ...adminUI,
  all,
  setDetails,
  scrapProducts,
  scrapProductsInventory
};
